module.exports = __webpack_public_path__ + "img/half-moon-and-stars.439f7be9.svg";